import { Description, Divider, Svg } from '@repo/ui';

import { ResultTableRow } from '@/components/tax-refund/apply/result/ResultTableRow';
import ApplyResultFaqView from '@/components/tax-refund/common/view/ApplyResultFaqView';
import { ApplyResultData } from '@/lib/types/request';

interface Props {
  data: Pick<ApplyResultData, 'businessType' | 'name' | 'fullName' | 'applyDate'>;
}

export const ApplyResultImpossibleContent = ({ data }: Props) => {
  const isCorporate = data.businessType === 'corps';
  const displayName = isCorporate ? (data.fullName ?? data.name) : data.name;
  const title = isCorporate ? `’${displayName}’의 검토 결과, 아쉽게도 환급이 어려워요...` : `${displayName}님의 검토 결과,\n아쉽게도 환급이 어려워요...`;
  const faqClickEvent = isCorporate ? 'corps-result_faq_no-refund' : 'indis-result_faq_no-refund';

  return (
    <div>
      <div className={'px-4.5 py-normal-small'}>
        <Description title={title} size={'medium'} graphic={<Svg src="icg_coin-dimmed_md.svg" width={80} height={80} />} />
      </div>
      <Divider />
      <div className={'px-4.5 py-tiny-large'}>
        <div className={'pb-normal-large'}>
          <ResultTableRow label={'환급 신청일'} value={data.applyDate} />
        </div>
      </div>
      <Divider size={'large'} />
      <ApplyResultFaqView
        data={[
          {
            title: '환급이 불가한 이유는 뭔가요?',
            content:
              '비즈넵 환급에서는 AI가 모든 적용 가능한 감면 내역을 적용해 환급금을 계산한 이후 제휴 세무 전문가가 추가로 검토하여 실제로 감면 적용이 가능한지 확인하고 있습니다. 이때 실제로 감면 적용이 어렵다고 확인된 경우, 환급이 불가합니다.'
          }
        ]}
        clickEventName={faqClickEvent}
      />
      <div className={'pb-normal-medium'} />
    </div>
  );
};
